// extracted by mini-css-extract-plugin
export default {"buttonsDiv":"FV","hideButtonBar":"GV","bottomRibbonContainer":"HV","scroll":"IV","default":"JV","nextBtn":"KV","MyClassEnterDone":"LV"};
    if(module.hot) {
      // 1730991511377
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  